import * as types from '../actions/types';

const initialState = {
  data: {
    periodNum: null,
    results: [],
  },
  loading: false,
  hasMore: true,
};

export default function (state = initialState, action) {
  const { payload, type, hasMore } = action;
  switch (type) {
    case types.GET_EVENT_RESULTS_REQUEST:
      return { ...state, loading: true };
    case types.GET_EVENT_RESULTS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: {
          periodNum:
            payload.periodNum < state.data.periodNum
              ? state.data.periodNum
              : payload.periodNum,
          results: [...state.data.results, ...payload.results],
        },
        hasMore,
      };
    case types.CLEAR_MATCH_RESULTS:
      return {
        ...state,
        hasMore: true,
        data: {
          periodNum: null,
          results: [],
        },
      };
    default:
      return state;
  }
}
